import React from 'react';
import { baseApiUrl, fetcher, ServerErrorResponse, createParamString } from 'data_sources/constants';
import { useInfiniteQuery } from 'react-query';
import { DTBPackageResponse, GetDTBPackageParams } from 'views/App/Portal/DTB/_types/dtb';

export default function useDTBPackages(
  params: GetDTBPackageParams,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  if (!params.orgId) {
    return {
      data: undefined,
      isFetching: false,
      isError: false,
      hasNextPage: false,
      fetchNextPage: () => Promise.resolve(),
      refetch: () => Promise.resolve(),
    } as any;
  }

  const packagesUrl = `${baseApiUrl()}/lexiverse/dtbs/v1/organizations/${params.orgId}/packages`;

  const packagesQuery = useInfiniteQuery<DTBPackageResponse, ServerErrorResponse>(
    ['dtbPackages', params],
    async ({ pageParam = '', signal }): Promise<DTBPackageResponse> => {
      try {
        const combinedParams = {
          ...params,
          nextToken: pageParam,
        };

        const paramString = createParamString(combinedParams);
        const resp = await fetcher({
          method: 'GET',
          url: `${packagesUrl}?${paramString}`,
          options: { signal },
        });
        return resp as DTBPackageResponse;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      ...options,
      keepPreviousData: true,
      getNextPageParam: (lastPage) => lastPage.nextToken || undefined,
    }
  );

  return {
    ...packagesQuery,
    data: packagesQuery.data,
  };
}
